const STORAGE_KEY = 'ab_tests';

function getStoredTests() {
  if (typeof localStorage === 'undefined') return {};
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function storeTests(tests) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tests));
  } catch { /* quota exceeded — fallback to in-memory */ }
}

/**
 * Returns a stable variant ('A' | 'B') for the given experiment name.
 * Assigned once per browser (persisted in localStorage).
 * Split is 50/50 by default.
 */
export function useABTest(experimentName, splitRatio = 0.5) {
  if (typeof localStorage === 'undefined') return 'A';

  const tests = getStoredTests();

  if (!tests[experimentName]) {
    tests[experimentName] = {
      variant: Math.random() < splitRatio ? 'A' : 'B',
      assignedAt: new Date().toISOString(),
    };
    storeTests(tests);
  }

  return tests[experimentName].variant;
}
